import { createFormHook, createFormHookContexts } from "@tanstack/react-form";

import { PhoneInputField } from "../components/form-fields/phone-input-field";
import { SelectInputField } from "../components/form-fields/select-input-field";
import { SubmitButton } from "../components/form-fields/submit-button";
import { TextAreaField } from "../components/form-fields/text-area-field";
import { TextInputField } from "../components/form-fields/text-input-field";

export const { fieldContext, formContext, useFieldContext, useFormContext } = createFormHookContexts();

export const { useAppForm, withForm } = createFormHook({
  fieldContext,
  formContext,
  fieldComponents: {
    TextInputField,
    TextAreaField,
    PhoneInputField,
    SelectInputField,
  },
  formComponents: {
    SubmitButton,
  },
});
